module.exports = __webpack_public_path__ + "static/media/riverfolk1.92c2d7a3.jpg";